/*****
  アポ獲得報告の投稿スケジュールチェック
******/
import axios from 'axios';

export default class {

  /******************************
    @param
      hook: string
      suggetion: string
      bussiness_format: string
      sheet: object
      mtg_add: string
      ap_doing_date: date
      ap_start_time: time
      raisha_area: string
      outlet_array: array
      loader: function
      today: date
  *******************************/
  constructor(param) {
    this.param = param
    this.exception_area_flag = false
    this.itzai_ng_outlet = ['②','⑥','⑦','⑧','⑪','⑯'];
    this.shukyaku_ng_outlet = ['②','⑦','⑧','⑪'];
    this.online_ng_outlet = ['⑨','⑩','⑬','⑭'];
    this.taimen_ng_outlet = ['②','⑦','⑧','⑪'];

    this.setRequiredStyle = (element) => {
      if (element) {
        element.classList.add('required');
      }
    }

    this.showElement = (element) => {
      if (element) {
        element.style.display = 'block';
      }
    }

    this.prefectures = [
      '北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県',
      '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県',
      '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県',
      '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県',
      '奈良県', '和歌山県', '鳥取県', '島根県', '岡山県', '広島県', '山口県',
      '徳島県', '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県',
      '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県'
    ];
    this.area = {
      '関東': ['東京都','千葉県','神奈川県','埼玉県'],
      '関西': ['大阪府','奈良県','滋賀県','京都府','兵庫県','和歌山県'],
      '東海': ['愛知県','岐阜県','三重県'],
      '九州': ['福岡県','佐賀県'],
      '東北': ['青森県','岩手県','秋田県','山形県','福島県'],
      '広島': ['広島県'],
      '岡山': ['岡山県'],
      '静岡': ['静岡県'],
      '浜松': ['浜松市'],
      '札幌': ['北海道'],
      '仙台': ['宮城県'],
      '北関東': ['栃木県','群馬県','茨城県'],
    }
    this.exception_area = {
      '関東': [],
      '関西': [],
      '東海': ['新潟県', '富山県', '石川県', '福井県'],
      '九州': ['長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県'],
      '東北': [],
      '広島': ['山口県', '島根県', '愛媛県', '高知県'],
      '岡山': ['鳥取県', '徳島県', '香川県'],
      '静岡': ['山梨県', '長野県'],
      '浜松': [],
      '札幌': [],
      '仙台': [],
      '北関東': [],
    }

    // 当日は 0 当日を起点に+1していく
    this.sheet_range = [
      {
        date: [4,0],
        'イツザイ': [
          { start: [5, 3], end: [5, 4], ng_outlet_1: [5, 5], ng_outlet_2: [5, 6] },
          { start: [6, 3], end: [6, 4], ng_outlet_1: [6, 5], ng_outlet_2: [6, 6] },
          { start: [7, 3], end: [7, 4], ng_outlet_1: [7, 5], ng_outlet_2: [7, 6] }
        ],
        'イツザイA': [
          { start: [8, 3], end: [8, 4], ng_outlet_1: [8, 5], ng_outlet_2: [8, 6] },
          { start: [9, 3], end: [9, 4], ng_outlet_1: [9, 5], ng_outlet_2: [9, 6] },
          { start: [10, 3], end: [10, 4], ng_outlet_1: [10, 5], ng_outlet_2: [10, 6] }
        ],
        'JOBY': [
          { start: [11, 3], end: [11, 4], ng_outlet_1: [11, 5], ng_outlet_2: [11, 6] },
          { start: [12, 3], end: [12, 4], ng_outlet_1: [12, 5], ng_outlet_2: [12, 6] },
          { start: [13, 3], end: [13, 4], ng_outlet_1: [13, 5], ng_outlet_2: [13, 6] }
        ],
        'Eaiser_イーウェル': [
          { start: [14, 3], end: [14, 4], ng_outlet_1: [14, 5], ng_outlet_2: [14, 6] },
          { start: [15, 3], end: [15, 4], ng_outlet_1: [15, 5], ng_outlet_2: [15, 6] },
          { start: [16, 3], end: [16, 4], ng_outlet_1: [16, 5], ng_outlet_2: [16, 6] }
        ],
        'Eaiser_WEB直販': [
          { start: [17, 3], end: [17, 4], ng_outlet_1: [17, 5], ng_outlet_2: [17, 6] },
          { start: [18, 3], end: [18, 4], ng_outlet_1: [18, 5], ng_outlet_2: [18, 6] },
          { start: [19, 3], end: [19, 4], ng_outlet_1: [19, 5], ng_outlet_2: [19, 6] }
        ],
      },
      {
        date: [21,0],
        'イツザイ': [
          { start: [22, 3], end: [22, 4], ng_outlet_1: [22, 5], ng_outlet_2: [22, 6] },
          { start: [23, 3], end: [23, 4], ng_outlet_1: [23, 5], ng_outlet_2: [23, 6] },
          { start: [24, 3], end: [24, 4], ng_outlet_1: [24, 5], ng_outlet_2: [24, 6] }
        ],
        'イツザイA': [
          { start: [25, 3], end: [25, 4], ng_outlet_1: [25, 5], ng_outlet_2: [25, 6] },
          { start: [26, 3], end: [26, 4], ng_outlet_1: [26, 5], ng_outlet_2: [26, 6] },
          { start: [27, 3], end: [27, 4], ng_outlet_1: [27, 5], ng_outlet_2: [27, 6] }
        ],
        'JOBY': [
          { start: [28, 3], end: [28, 4], ng_outlet_1: [28, 5], ng_outlet_2: [28, 6] },
          { start: [29, 3], end: [29, 4], ng_outlet_1: [29, 5], ng_outlet_2: [29, 6] },
          { start: [30, 3], end: [30, 4], ng_outlet_1: [30, 5], ng_outlet_2: [30, 6] }
        ],
        'Eaiser_イーウェル': [
          { start: [31, 3], end: [31, 4], ng_outlet_1: [31, 5], ng_outlet_2: [31, 6] },
          { start: [32, 3], end: [32, 4], ng_outlet_1: [32, 5], ng_outlet_2: [32, 6] },
          { start: [33, 3], end: [33, 4], ng_outlet_1: [33, 5], ng_outlet_2: [33, 6] }
        ],
        'Eaiser_WEB直販': [
          { start: [34, 3], end: [34, 4], ng_outlet_1: [34, 5], ng_outlet_2: [34, 6] },
          { start: [35, 3], end: [35, 4], ng_outlet_1: [35, 5], ng_outlet_2: [35, 6] },
          { start: [36, 3], end: [36, 4], ng_outlet_1: [36, 5], ng_outlet_2: [36, 6] }
        ],
      },
      {
        date: [38,0],
        'イツザイ': [
          { start: [39, 3], end: [39, 4], ng_outlet_1: [39, 5], ng_outlet_2: [39, 6] },
          { start: [40, 3], end: [40, 4], ng_outlet_1: [40, 5], ng_outlet_2: [40, 6] },
          { start: [41, 3], end: [41, 4], ng_outlet_1: [41, 5], ng_outlet_2: [41, 6] }
        ],
        'イツザイA': [
          { start: [42, 3], end: [42, 4], ng_outlet_1: [42, 5], ng_outlet_2: [42, 6] },
          { start: [43, 3], end: [43, 4], ng_outlet_1: [43, 5], ng_outlet_2: [43, 6] },
          { start: [44, 3], end: [44, 4], ng_outlet_1: [44, 5], ng_outlet_2: [44, 6] }
        ],
        'JOBY': [
          { start: [45, 3], end: [45, 4], ng_outlet_1: [45, 5], ng_outlet_2: [45, 6] },
          { start: [46, 3], end: [46, 4], ng_outlet_1: [46, 5], ng_outlet_2: [46, 6] },
          { start: [47, 3], end: [47, 4], ng_outlet_1: [47, 5], ng_outlet_2: [47, 6] }
        ],
        'Eaiser_イーウェル': [
          { start: [48, 3], end: [48, 4], ng_outlet_1: [48, 5], ng_outlet_2: [48, 6] },
          { start: [49, 3], end: [49, 4], ng_outlet_1: [49, 5], ng_outlet_2: [49, 6] },
          { start: [50, 3], end: [50, 4], ng_outlet_1: [50, 5], ng_outlet_2: [50, 6] }
        ],
        'Eaiser_WEB直販': [
          { start: [51, 3], end: [51, 4], ng_outlet_1: [51, 5], ng_outlet_2: [51, 6] },
          { start: [52, 3], end: [52, 4], ng_outlet_1: [52, 5], ng_outlet_2: [52, 6] },
          { start: [53, 3], end: [53, 4], ng_outlet_1: [53, 5], ng_outlet_2: [53, 6] }
        ],
      },
      {
        date: [55,0],
        'イツザイ': [
          { start: [56, 3], end: [56, 4], ng_outlet_1: [56, 5], ng_outlet_2: [56, 6] },
          { start: [57, 3], end: [57, 4], ng_outlet_1: [57, 5], ng_outlet_2: [57, 6] },
          { start: [58, 3], end: [58, 4], ng_outlet_1: [58, 5], ng_outlet_2: [58, 6] }
        ],
        'イツザイA': [
          { start: [59, 3], end: [59, 4], ng_outlet_1: [59, 5], ng_outlet_2: [59, 6] },
          { start: [60, 3], end: [60, 4], ng_outlet_1: [60, 5], ng_outlet_2: [60, 6] },
          { start: [61, 3], end: [61, 4], ng_outlet_1: [61, 5], ng_outlet_2: [61, 6] }
        ],
        'JOBY': [
          { start: [62, 3], end: [62, 4], ng_outlet_1: [62, 5], ng_outlet_2: [62, 6] },
          { start: [63, 3], end: [63, 4], ng_outlet_1: [63, 5], ng_outlet_2: [63, 6] },
          { start: [64, 3], end: [64, 4], ng_outlet_1: [64, 5], ng_outlet_2: [64, 6] }
        ],
        'Eaiser_イーウェル': [
          { start: [65, 3], end: [65, 4], ng_outlet_1: [65, 5], ng_outlet_2: [65, 6] },
          { start: [66, 3], end: [66, 4], ng_outlet_1: [66, 5], ng_outlet_2: [66, 6] },
          { start: [67, 3], end: [67, 4], ng_outlet_1: [67, 5], ng_outlet_2: [67, 6] }
        ],
        'Eaiser_WEB直販': [
          { start: [68, 3], end: [68, 4], ng_outlet_1: [68, 5], ng_outlet_2: [68, 6] },
          { start: [69, 3], end: [69, 4], ng_outlet_1: [69, 5], ng_outlet_2: [69, 6] },
          { start: [70, 3], end: [70, 4], ng_outlet_1: [70, 5], ng_outlet_2: [70, 6] }
        ],
      },
      {
        date: [72,0],
        'イツザイ': [
          { start: [73, 3], end: [73, 4], ng_outlet_1: [73, 5], ng_outlet_2: [73, 6] },
          { start: [74, 3], end: [74, 4], ng_outlet_1: [74, 5], ng_outlet_2: [74, 6] },
          { start: [75, 3], end: [75, 4], ng_outlet_1: [75, 5], ng_outlet_2: [75, 6] }
        ],
        'イツザイA': [
          { start: [76, 3], end: [76, 4], ng_outlet_1: [76, 5], ng_outlet_2: [76, 6] },
          { start: [77, 3], end: [77, 4], ng_outlet_1: [77, 5], ng_outlet_2: [77, 6] },
          { start: [78, 3], end: [78, 4], ng_outlet_1: [78, 5], ng_outlet_2: [78, 6] }
        ],
        'JOBY': [
          { start: [79, 3], end: [79, 4], ng_outlet_1: [79, 5], ng_outlet_2: [79, 6] },
          { start: [80, 3], end: [80, 4], ng_outlet_1: [80, 5], ng_outlet_2: [80, 6] },
          { start: [81, 3], end: [81, 4], ng_outlet_1: [81, 5], ng_outlet_2: [81, 6] }
        ],
        'Eaiser_イーウェル': [
          { start: [82, 3], end: [82, 4], ng_outlet_1: [82, 5], ng_outlet_2: [82, 6] },
          { start: [83, 3], end: [83, 4], ng_outlet_1: [83, 5], ng_outlet_2: [83, 6] },
          { start: [84, 3], end: [84, 4], ng_outlet_1: [84, 5], ng_outlet_2: [84, 6] }
        ],
        'Eaiser_WEB直販': [
          { start: [85, 3], end: [85, 4], ng_outlet_1: [85, 5], ng_outlet_2: [85, 6] },
          { start: [86, 3], end: [86, 4], ng_outlet_1: [86, 5], ng_outlet_2: [86, 6] },
          { start: [87, 3], end: [87, 4], ng_outlet_1: [87, 5], ng_outlet_2: [87, 6] }
        ],
      },
      {
        date: [89,0],
        'イツザイ': [
          { start: [90, 3], end: [90, 4], ng_outlet_1: [90, 5], ng_outlet_2: [90, 6] },
          { start: [91, 3], end: [91, 4], ng_outlet_1: [91, 5], ng_outlet_2: [91, 6] },
          { start: [92, 3], end: [92, 4], ng_outlet_1: [92, 5], ng_outlet_2: [92, 6] }
        ],
        'イツザイA': [
          { start: [93, 3], end: [93, 4], ng_outlet_1: [93, 5], ng_outlet_2: [93, 6] },
          { start: [94, 3], end: [94, 4], ng_outlet_1: [94, 5], ng_outlet_2: [94, 6] },
          { start: [95, 3], end: [95, 4], ng_outlet_1: [95, 5], ng_outlet_2: [95, 6] }
        ],
        'JOBY': [
          { start: [96, 3], end: [96, 4], ng_outlet_1: [96, 5], ng_outlet_2: [96, 6] },
          { start: [97, 3], end: [97, 4], ng_outlet_1: [97, 5], ng_outlet_2: [97, 6] },
          { start: [98, 3], end: [98, 4], ng_outlet_1: [98, 5], ng_outlet_2: [98, 6] }
        ],
        'Eaiser_イーウェル': [
          { start: [99, 3], end: [99, 4], ng_outlet_1: [99, 5], ng_outlet_2: [99, 6] },
          { start: [100, 3], end: [100, 4], ng_outlet_1: [100, 5], ng_outlet_2: [100, 6] },
          { start: [101, 3], end: [101, 4], ng_outlet_1: [101, 5], ng_outlet_2: [101, 6] }
        ],
        'Eaiser_WEB直販': [
          { start: [102, 3], end: [102, 4], ng_outlet_1: [102, 5], ng_outlet_2: [102, 6] },
          { start: [103, 3], end: [103, 4], ng_outlet_1: [103, 5], ng_outlet_2: [103, 6] },
          { start: [104, 3], end: [104, 4], ng_outlet_1: [104, 5], ng_outlet_2: [104, 6] }
        ],
      },
      {
        date: [106,0],
        'イツザイ': [
          { start: [107, 3], end: [107, 4], ng_outlet_1: [107, 5], ng_outlet_2: [107, 6] },
          { start: [108, 3], end: [108, 4], ng_outlet_1: [108, 5], ng_outlet_2: [108, 6] },
          { start: [109, 3], end: [109, 4], ng_outlet_1: [109, 5], ng_outlet_2: [109, 6] }
        ],
        'イツザイA': [
          { start: [110, 3], end: [110, 4], ng_outlet_1: [110, 5], ng_outlet_2: [110, 6] },
          { start: [111, 3], end: [111, 4], ng_outlet_1: [111, 5], ng_outlet_2: [111, 6] },
          { start: [112, 3], end: [112, 4], ng_outlet_1: [112, 5], ng_outlet_2: [112, 6] }
        ],
        'JOBY': [
          { start: [113, 3], end: [113, 4], ng_outlet_1: [113, 5], ng_outlet_2: [113, 6] },
          { start: [114, 3], end: [114, 4], ng_outlet_1: [114, 5], ng_outlet_2: [114, 6] },
          { start: [115, 3], end: [115, 4], ng_outlet_1: [115, 5], ng_outlet_2: [115, 6] }
        ],
        'Eaiser_イーウェル': [
          { start: [116, 3], end: [116, 4], ng_outlet_1: [116, 5], ng_outlet_2: [116, 6] },
          { start: [117, 3], end: [117, 4], ng_outlet_1: [117, 5], ng_outlet_2: [117, 6] },
          { start: [118, 3], end: [118, 4], ng_outlet_1: [118, 5], ng_outlet_2: [118, 6] }
        ],
        'Eaiser_WEB直販': [
          { start: [119, 3], end: [119, 4], ng_outlet_1: [119, 5], ng_outlet_2: [119, 6] },
          { start: [120, 3], end: [120, 4], ng_outlet_1: [120, 5], ng_outlet_2: [120, 6] },
          { start: [121, 3], end: [121, 4], ng_outlet_1: [121, 5], ng_outlet_2: [121, 6] }
        ],
      },
      {
        date: [123,0],
        'イツザイ': [
          { start: [124, 3], end: [124, 4], ng_outlet_1: [124, 5], ng_outlet_2: [124, 6] },
          { start: [125, 3], end: [125, 4], ng_outlet_1: [125, 5], ng_outlet_2: [125, 6] },
          { start: [126, 3], end: [126, 4], ng_outlet_1: [126, 5], ng_outlet_2: [126, 6] }
        ],
        'イツザイA': [
          { start: [127, 3], end: [127, 4], ng_outlet_1: [127, 5], ng_outlet_2: [127, 6] },
          { start: [128, 3], end: [128, 4], ng_outlet_1: [128, 5], ng_outlet_2: [128, 6] },
          { start: [129, 3], end: [129, 4], ng_outlet_1: [129, 5], ng_outlet_2: [129, 6] }
        ],
        'JOBY': [
          { start: [130, 3], end: [130, 4], ng_outlet_1: [130, 5], ng_outlet_2: [130, 6] },
          { start: [131, 3], end: [131, 4], ng_outlet_1: [131, 5], ng_outlet_2: [131, 6] },
          { start: [132, 3], end: [132, 4], ng_outlet_1: [132, 5], ng_outlet_2: [132, 6] }
        ],
        'Eaiser_イーウェル': [
          { start: [133, 3], end: [133, 4], ng_outlet_1: [133, 5], ng_outlet_2: [133, 6] },
          { start: [134, 3], end: [134, 4], ng_outlet_1: [134, 5], ng_outlet_2: [134, 6] },
          { start: [135, 3], end: [135, 4], ng_outlet_1: [135, 5], ng_outlet_2: [135, 6] }
        ],
        'Eaiser_WEB直販': [
          { start: [136, 3], end: [136, 4], ng_outlet_1: [136, 5], ng_outlet_2: [136, 6] },
          { start: [137, 3], end: [137, 4], ng_outlet_1: [137, 5], ng_outlet_2: [137, 6] },
          { start: [138, 3], end: [138, 4], ng_outlet_1: [138, 5], ng_outlet_2: [138, 6] }
        ],
      },
      {
        date: [140,0],
        'イツザイ': [
          { start: [141, 3], end: [141, 4], ng_outlet_1: [141, 5], ng_outlet_2: [141, 6] },
          { start: [142, 3], end: [142, 4], ng_outlet_1: [142, 5], ng_outlet_2: [142, 6] },
          { start: [143, 3], end: [143, 4], ng_outlet_1: [143, 5], ng_outlet_2: [143, 6] }
        ],
        'イツザイA': [
          { start: [144, 3], end: [144, 4], ng_outlet_1: [144, 5], ng_outlet_2: [144, 6] },
          { start: [145, 3], end: [145, 4], ng_outlet_1: [145, 5], ng_outlet_2: [145, 6] },
          { start: [146, 3], end: [146, 4], ng_outlet_1: [146, 5], ng_outlet_2: [146, 6] }
        ],
        'JOBY': [
          { start: [147, 3], end: [147, 4], ng_outlet_1: [147, 5], ng_outlet_2: [147, 6] },
          { start: [148, 3], end: [148, 4], ng_outlet_1: [148, 5], ng_outlet_2: [148, 6] },
          { start: [149, 3], end: [149, 4], ng_outlet_1: [149, 5], ng_outlet_2: [149, 6] }
        ],
        'Eaiser_イーウェル': [
          { start: [150, 3], end: [150, 4], ng_outlet_1: [150, 5], ng_outlet_2: [150, 6] },
          { start: [151, 3], end: [151, 4], ng_outlet_1: [151, 5], ng_outlet_2: [151, 6] },
          { start: [152, 3], end: [152, 4], ng_outlet_1: [152, 5], ng_outlet_2: [152, 6] }
        ],
        'Eaiser_WEB直販': [
          { start: [153, 3], end: [153, 4], ng_outlet_1: [153, 5], ng_outlet_2: [153, 6] },
          { start: [154, 3], end: [154, 4], ng_outlet_1: [154, 5], ng_outlet_2: [154, 6] },
          { start: [155, 3], end: [155, 4], ng_outlet_1: [155, 5], ng_outlet_2: [155, 6] }
        ],
      },
      {
        date: [157,0],
        'イツザイ': [
          { start: [158, 3], end: [158, 4], ng_outlet_1: [158, 5], ng_outlet_2: [158, 6] },
          { start: [159, 3], end: [159, 4], ng_outlet_1: [159, 5], ng_outlet_2: [159, 6] },
          { start: [160, 3], end: [160, 4], ng_outlet_1: [160, 5], ng_outlet_2: [160, 6] }
        ],
        'イツザイA': [
          { start: [161, 3], end: [161, 4], ng_outlet_1: [161, 5], ng_outlet_2: [161, 6] },
          { start: [162, 3], end: [162, 4], ng_outlet_1: [162, 5], ng_outlet_2: [162, 6] },
          { start: [163, 3], end: [163, 4], ng_outlet_1: [163, 5], ng_outlet_2: [163, 6] }
        ],
        'JOBY': [
          { start: [164, 3], end: [164, 4], ng_outlet_1: [164, 5], ng_outlet_2: [164, 6] },
          { start: [165, 3], end: [165, 4], ng_outlet_1: [165, 5], ng_outlet_2: [165, 6] },
          { start: [166, 3], end: [166, 4], ng_outlet_1: [166, 5], ng_outlet_2: [166, 6] }
        ],
        'Eaiser_イーウェル': [
          { start: [167, 3], end: [167, 4], ng_outlet_1: [167, 5], ng_outlet_2: [167, 6] },
          { start: [168, 3], end: [168, 4], ng_outlet_1: [168, 5], ng_outlet_2: [168, 6] },
          { start: [169, 3], end: [169, 4], ng_outlet_1: [169, 5], ng_outlet_2: [169, 6] }
        ],
        'Eaiser_WEB直販': [
          { start: [170, 3], end: [170, 4], ng_outlet_1: [170, 5], ng_outlet_2: [170, 6] },
          { start: [171, 3], end: [171, 4], ng_outlet_1: [171, 5], ng_outlet_2: [171, 6] },
          { start: [172, 3], end: [172, 4], ng_outlet_1: [172, 5], ng_outlet_2: [172, 6] }
        ],
      },
      {
        date: [174,0],
        'イツザイ': [
          { start: [175, 3], end: [175, 4], ng_outlet_1: [175, 5], ng_outlet_2: [175, 6] },
          { start: [176, 3], end: [176, 4], ng_outlet_1: [176, 5], ng_outlet_2: [176, 6] },
          { start: [177, 3], end: [177, 4], ng_outlet_1: [177, 5], ng_outlet_2: [177, 6] }
        ],
        'イツザイA': [
          { start: [178, 3], end: [178, 4], ng_outlet_1: [178, 5], ng_outlet_2: [178, 6] },
          { start: [179, 3], end: [179, 4], ng_outlet_1: [179, 5], ng_outlet_2: [179, 6] },
          { start: [180, 3], end: [180, 4], ng_outlet_1: [180, 5], ng_outlet_2: [180, 6] }
        ],
        'JOBY': [
          { start: [181, 3], end: [181, 4], ng_outlet_1: [181, 5], ng_outlet_2: [181, 6] },
          { start: [182, 3], end: [182, 4], ng_outlet_1: [182, 5], ng_outlet_2: [182, 6] },
          { start: [183, 3], end: [183, 4], ng_outlet_1: [183, 5], ng_outlet_2: [183, 6] }
        ],
        'Eaiser_イーウェル': [
          { start: [184, 3], end: [184, 4], ng_outlet_1: [184, 5], ng_outlet_2: [184, 6] },
          { start: [185, 3], end: [185, 4], ng_outlet_1: [185, 5], ng_outlet_2: [185, 6] },
          { start: [186, 3], end: [186, 4], ng_outlet_1: [186, 5], ng_outlet_2: [186, 6] }
        ],
        'Eaiser_WEB直販': [
          { start: [187, 3], end: [187, 4], ng_outlet_1: [187, 5], ng_outlet_2: [187, 6] },
          { start: [188, 3], end: [188, 4], ng_outlet_1: [188, 5], ng_outlet_2: [188, 6] },
          { start: [189, 3], end: [189, 4], ng_outlet_1: [189, 5], ng_outlet_2: [189, 6] }
        ],
      },
      {
        date: [191,0],
        'イツザイ': [
          { start: [192, 3], end: [192, 4], ng_outlet_1: [192, 5], ng_outlet_2: [192, 6] },
          { start: [193, 3], end: [193, 4], ng_outlet_1: [193, 5], ng_outlet_2: [193, 6] },
          { start: [194, 3], end: [194, 4], ng_outlet_1: [194, 5], ng_outlet_2: [194, 6] }
        ],
        'イツザイA': [
          { start: [195, 3], end: [195, 4], ng_outlet_1: [195, 5], ng_outlet_2: [195, 6] },
          { start: [196, 3], end: [196, 4], ng_outlet_1: [196, 5], ng_outlet_2: [196, 6] },
          { start: [197, 3], end: [197, 4], ng_outlet_1: [197, 5], ng_outlet_2: [197, 6] }
        ],
        'JOBY': [
          { start: [198, 3], end: [198, 4], ng_outlet_1: [198, 5], ng_outlet_2: [198, 6] },
          { start: [199, 3], end: [199, 4], ng_outlet_1: [199, 5], ng_outlet_2: [199, 6] },
          { start: [200, 3], end: [200, 4], ng_outlet_1: [200, 5], ng_outlet_2: [200, 6] }
        ],
        'Eaiser_イーウェル': [
          { start: [201, 3], end: [201, 4], ng_outlet_1: [201, 5], ng_outlet_2: [201, 6] },
          { start: [202, 3], end: [202, 4], ng_outlet_1: [202, 5], ng_outlet_2: [202, 6] },
          { start: [203, 3], end: [203, 4], ng_outlet_1: [203, 5], ng_outlet_2: [203, 6] }
        ],
        'Eaiser_WEB直販': [
          { start: [204, 3], end: [204, 4], ng_outlet_1: [204, 5], ng_outlet_2: [204, 6] },
          { start: [205, 3], end: [205, 4], ng_outlet_1: [205, 5], ng_outlet_2: [205, 6] },
          { start: [206, 3], end: [206, 4], ng_outlet_1: [206, 5], ng_outlet_2: [206, 6] }
        ],
      },
      {
        date: [208,0],
        'イツザイ': [
          { start: [209, 3], end: [209, 4], ng_outlet_1: [209, 5], ng_outlet_2: [209, 6] },
          { start: [210, 3], end: [210, 4], ng_outlet_1: [210, 5], ng_outlet_2: [210, 6] },
          { start: [211, 3], end: [211, 4], ng_outlet_1: [211, 5], ng_outlet_2: [211, 6] }
        ],
        'イツザイA': [
          { start: [212, 3], end: [212, 4], ng_outlet_1: [212, 5], ng_outlet_2: [212, 6] },
          { start: [213, 3], end: [213, 4], ng_outlet_1: [213, 5], ng_outlet_2: [213, 6] },
          { start: [214, 3], end: [214, 4], ng_outlet_1: [214, 5], ng_outlet_2: [214, 6] }
        ],
        'JOBY': [
          { start: [215, 3], end: [215, 4], ng_outlet_1: [215, 5], ng_outlet_2: [215, 6] },
          { start: [216, 3], end: [216, 4], ng_outlet_1: [216, 5], ng_outlet_2: [216, 6] },
          { start: [217, 3], end: [217, 4], ng_outlet_1: [217, 5], ng_outlet_2: [217, 6] }
        ],
        'Eaiser_イーウェル': [
          { start: [218, 3], end: [218, 4], ng_outlet_1: [218, 5], ng_outlet_2: [218, 6] },
          { start: [219, 3], end: [219, 4], ng_outlet_1: [219, 5], ng_outlet_2: [219, 6] },
          { start: [220, 3], end: [220, 4], ng_outlet_1: [220, 5], ng_outlet_2: [220, 6] }
        ],
        'Eaiser_WEB直販': [
          { start: [221, 3], end: [221, 4], ng_outlet_1: [221, 5], ng_outlet_2: [221, 6] },
          { start: [222, 3], end: [222, 4], ng_outlet_1: [222, 5], ng_outlet_2: [222, 6] },
          { start: [223, 3], end: [223, 4], ng_outlet_1: [223, 5], ng_outlet_2: [223, 6] }
        ],
      },
      {
        date: [225,0],
        'イツザイ': [
          { start: [226, 3], end: [226, 4], ng_outlet_1: [226, 5], ng_outlet_2: [226, 6] },
          { start: [227, 3], end: [227, 4], ng_outlet_1: [227, 5], ng_outlet_2: [227, 6] },
          { start: [228, 3], end: [228, 4], ng_outlet_1: [228, 5], ng_outlet_2: [228, 6] }
        ],
        'イツザイA': [
          { start: [229, 3], end: [229, 4], ng_outlet_1: [229, 5], ng_outlet_2: [229, 6] },
          { start: [230, 3], end: [230, 4], ng_outlet_1: [230, 5], ng_outlet_2: [230, 6] },
          { start: [231, 3], end: [231, 4], ng_outlet_1: [231, 5], ng_outlet_2: [231, 6] }
        ],
        'JOBY': [
          { start: [232, 3], end: [232, 4], ng_outlet_1: [232, 5], ng_outlet_2: [232, 6] },
          { start: [233, 3], end: [233, 4], ng_outlet_1: [233, 5], ng_outlet_2: [233, 6] },
          { start: [234, 3], end: [234, 4], ng_outlet_1: [234, 5], ng_outlet_2: [234, 6] }
        ],
        'Eaiser_イーウェル': [
          { start: [235, 3], end: [235, 4], ng_outlet_1: [235, 5], ng_outlet_2: [235, 6] },
          { start: [236, 3], end: [236, 4], ng_outlet_1: [236, 5], ng_outlet_2: [236, 6] },
          { start: [237, 3], end: [237, 4], ng_outlet_1: [237, 5], ng_outlet_2: [237, 6] }
        ],
        'Eaiser_WEB直販': [
          { start: [238, 3], end: [238, 4], ng_outlet_1: [238, 5], ng_outlet_2: [238, 6] },
          { start: [239, 3], end: [239, 4], ng_outlet_1: [239, 5], ng_outlet_2: [239, 6] },
          { start: [240, 3], end: [240, 4], ng_outlet_1: [240, 5], ng_outlet_2: [240, 6] }
        ],
      },
      {
        date: [242,0],
        'イツザイ': [
          { start: [243, 3], end: [243, 4], ng_outlet_1: [243, 5], ng_outlet_2: [243, 6] },
          { start: [244, 3], end: [244, 4], ng_outlet_1: [244, 5], ng_outlet_2: [244, 6] },
          { start: [245, 3], end: [245, 4], ng_outlet_1: [245, 5], ng_outlet_2: [245, 6] }
        ],
        'イツザイA': [
          { start: [246, 3], end: [246, 4], ng_outlet_1: [246, 5], ng_outlet_2: [246, 6] },
          { start: [247, 3], end: [247, 4], ng_outlet_1: [247, 5], ng_outlet_2: [247, 6] },
          { start: [248, 3], end: [248, 4], ng_outlet_1: [248, 5], ng_outlet_2: [248, 6] }
        ],
        'JOBY': [
          { start: [249, 3], end: [249, 4], ng_outlet_1: [249, 5], ng_outlet_2: [249, 6] },
          { start: [250, 3], end: [250, 4], ng_outlet_1: [250, 5], ng_outlet_2: [250, 6] },
          { start: [251, 3], end: [251, 4], ng_outlet_1: [251, 5], ng_outlet_2: [251, 6] }
        ],
        'Eaiser_イーウェル': [
          { start: [252, 3], end: [252, 4], ng_outlet_1: [252, 5], ng_outlet_2: [252, 6] },
          { start: [253, 3], end: [253, 4], ng_outlet_1: [253, 5], ng_outlet_2: [253, 6] },
          { start: [254, 3], end: [254, 4], ng_outlet_1: [254, 5], ng_outlet_2: [254, 6] }
        ],
        'Eaiser_WEB直販': [
          { start: [255, 3], end: [255, 4], ng_outlet_1: [255, 5], ng_outlet_2: [255, 6] },
          { start: [256, 3], end: [256, 4], ng_outlet_1: [256, 5], ng_outlet_2: [256, 6] },
          { start: [257, 3], end: [257, 4], ng_outlet_1: [257, 5], ng_outlet_2: [257, 6] }
        ],
      },
    ]

    return this.checkProccess();
  }

  async checkProccess() {
    this.param.loader('営業スケジュールチェック開始');

    this.setSheetURL();

    let result = await this.getSheetData();
  
    if(result.status == 'error') {
      this.loadingEnd(result.message);
      return result;
    }

    let exception_area_message = '';

    result = this.checkDateSet();
    console.log(result)
    if((result.status == 'error' || result.status == 'attention') && this.exception_area_flag) {
      exception_area_message += "日付"
    } else if ((result.status == 'error' || result.status == 'attention')) {
      this.loadingEnd(result.message);
      return result;
    }

    result = this.checkBussinessHour();
    console.log(result)
    if((result.status == 'error' || result.status == 'warning') && this.exception_area_flag) {
      exception_area_message += "商談時間"
    } else if(result.status == 'error' || result.status == 'warning') {
      this.loadingEnd(result.message);
      return result;
    }

    result = this.checkOutlet();
    console.log(result)
    if((result.status == 'error') && this.exception_area_flag) {
      exception_area_message += "アウトレット条件"
    } else if(result.status == 'error') {
      this.loadingEnd(result.message);
      return result;
    }

    if(this.exception_area_flag) {
      const permitElements = document.querySelectorAll('.schedule_permit')
      permitElements.forEach(this.showElement)
      const permitter = document.getElementById('permitter')
      const permitDetails = document.getElementById('permitDetails')
      this.setRequiredStyle(permitter)
      this.setRequiredStyle(permitDetails)
      let message = '商談エリア外のエリアを指定しています。\n営業スケジュールシートを確認してください。\n\n上長に許可をいただいた場合は\n投稿ボタン上の許可済みボタンにチェックしてください。'
      message += exception_area_message ? '\n\nまた、暫定で' + this.sheet_name + 'のシートを確認したところ\n'+ exception_area_message + ' が指定外となっているようなので\n問題ないか合わせて確認してください。' : ''
      result = {
        status: 'error',
        message: message,
        error_type: '対面'
      }
      this.loadingEnd(result.message);
      return result;
    }

    return result;
  }

  setSheetURL() {
    let name = '';

    if( this.param.bussiness_format !== 'オンライン' ) {
      if( this.param.bussiness_format.indexOf('来社') > -1 ) {
        name = this.param.raisha_area;

        switch(name) {
          case '東京':
          case '秋葉原': {
            name = '東京都';
            break;
          }
          case '大阪': {
            name = name + '府';
            break;
          }
          case '広島':
          case '福岡': {
            name = name + '県';
            break;
          }
          case '名古屋': {
            name = '愛知県';
            break;
          }
          case '横浜': {
            name = '神奈川県';
            break;
          }
          case '札幌': {
            name = '北海道';
            break;
          }
          case '仙台': {
            name = '宮城県';
            break;
          }
        }

        this.param.mtg_add = name;
        name = this.getAreaName();

        if(!name) this.param.bussiness_format = 'オンライン';
      }

      if( this.param.bussiness_format.match(/カフェ|訪問/)) {
        name = this.getAreaName();
      }

      name = this.param.sheet.names.filter(s_name => s_name.indexOf(name) > -1);
    }

    if( this.param.bussiness_format == 'オンライン' ) {
      name = this.param.sheet.names.filter(s_name => s_name.indexOf('オンライン') > -1);
    }

    this.sheet_name = name;
  }

  async getSheetData() {
    try {
      const spreadID = this.param.prod ? this.param.sheet.id : this.param.sheet.demo_id
      const spreadUpdateRequestBody = {
        "spread": {
          "id": spreadID,
          "sheet_name": this.sheet_name[0]
        },
        "all_records": {}
      }

      await fetch(this.param.api, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'X-Cal-St-Api': this.param.key
        },
        body: JSON.stringify(spreadUpdateRequestBody)
      })
      .then(res => res.json())
      .then(data => {
        this.sheet_data = data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });

      return {
        status: 'ok',
        message: '営業スケジュール取得完了'
      };

    } catch (e) {
      console.error(e);
      return {
        status: 'error',
        message: '営業スケジュール取得失敗\nお手数ですが再投稿してください'
      };
    }
  }

  getAreaName() {
    const regex = new RegExp(this.prefectures.join('|'), 'g');
    const match = this.param.mtg_add.match(regex);

    if(this.param.mtg_add.includes('浜松市')) {
      return '浜松';
    }

    if (match) {
      const prefecture = match[0];
      console.log('都道府県名:', prefecture);
    
      const matching_key = Object.keys(this.area).find(key => this.area[key].includes(prefecture));
      const matching_exception_area_key = Object.keys(this.exception_area).find(key => this.exception_area[key].includes(prefecture));

      if (matching_key) {
        console.log('マッチするキー:', matching_key);
        return matching_key;
      } else if (matching_exception_area_key) {
        console.log('マッチするキー:', matching_exception_area_key);
        this.exception_area_flag = true;
        return matching_exception_area_key;
      } else {
        console.log('都道府県名がエリアに見つかりませんでした');
        return false;
      }
    } else {
      console.log('都道府県名が見つかりませんでした');
    }
  }

  checkDateSet() {
    // イージアの場合
    this.date_set = [];

    let sheet_range = this.sheet_range;

    let check_date = '';
    if( this.param.today == this.param.ap_doing_date ) { 
      check_date = '当アポ';
    } else {
      check_date = this.param.ap_doing_date.match(/[0-9]{2}$/)[0].replace(/^0/,'') + '日';
    }

    try {
      this.date_set = sheet_range.filter((range, i) => {
        
        let row = range.date[0];
        let col = range.date[1];

        if (check_date == '当アポ') {
          if(this.sheet_data[row][col].includes(check_date)) {
            return sheet_range[i];
          }
        } else {
          if(this.sheet_data[row][col] == check_date) {
            return sheet_range[i];
          }
        }
  
        return false;
      });

      if(this.date_set.length == 0) {
        const permitElements = document.querySelectorAll('.schedule_permit')
        permitElements.forEach(this.showElement)
        const permitter = document.getElementById('permitter')
        const permitDetails = document.getElementById('permitDetails')
        this.setRequiredStyle(permitter)
        this.setRequiredStyle(permitDetails)
        return {
          status: 'error',
          message: '該当する日付が営業スケジュールにありません。\n日程を確認してください。\n\n上長に許可をいただいた場合は\n投稿ボタン上の許可済みボタンにチェックしてください。',
          error_type: '時間'
        }
      } else {
        const permitElements = document.querySelectorAll('.schedule_permit')
        permitElements.forEach(this.showElement)
        const permitter = document.getElementById('permitter')
        const permitDetails = document.getElementById('permitDetails')
        this.setRequiredStyle(permitter)
        this.setRequiredStyle(permitDetails)
        return {
          status: 'ok',
          message: '選択した日付に該当する営業スケジュールを取得しました'
        }
      }

    } catch(e) {
      console.error(e);
      return {
        status: 'error',
        message: '日付の指定に失敗しました。\n営業スケジュールシートのレイアウトを\n確認してください。'
      }
    }
  }

  checkBussinessHour() {
    let check_hour_set = [];
    this.ng_outlet_1 = '';
    this.ng_outlet_2 = '';
    
    if(this.date_set.length > 0 ) {
      if( this.param.hook == 'W' ) {
        check_hour_set = this.date_set[0]['Eaiser_イーウェル'];
      } else if( this.param.hook == 'イツザイ' || this.param.suggestion == 'イツザイ' ) {
        check_hour_set = this.date_set[0]['イツザイ'];
      } else if ( this.param.hook == 'JOBY' && this.param.suggestion == 'JOBY' ) {
        check_hour_set = this.date_set[0]['JOBY'];
      } else {
        check_hour_set = this.date_set[0]['Eaiser_WEB直販'];
      }
    } else {
      return {
        status: 'warning',
        message: 'アポ日付が営業スケジュールの範囲外ですが処理を続行します'
      }
    }

    if(check_hour_set.length > 0) {        
      let result = 0;
      for(let i in check_hour_set) {

        if (!this.sheet_data[check_hour_set[i].start[0]] || !this.sheet_data[check_hour_set[i].end[0]]) {
          console.log('該当行のデータが存在しません:', check_hour_set[i])
          continue
        }

        const start = this.sheet_data[check_hour_set[i].start[0]][check_hour_set[i].start[1]]
        const end = this.sheet_data[check_hour_set[i].end[0]][check_hour_set[i].end[1]]

        if(start && end) {
          const check_time = this.checkTime(this.param.ap_start_time, start, end);

          if(check_time == 1) {
            this.ng_outlet_1 = this.sheet_data[check_hour_set[i].ng_outlet_1[0]][check_hour_set[i].ng_outlet_1[1]]
            this.ng_outlet_2 = this.sheet_data[check_hour_set[i].ng_outlet_2[0]][check_hour_set[i].ng_outlet_2[1]]
          }

          result += check_time;
        }
      }

      if(result == 1) {
        return {
          status: 'ok',
          message: '営業時間内もしくは指定なし'
        }
      } else {
        const permitElements = document.querySelectorAll('.schedule_permit')
        permitElements.forEach(this.showElement)
        const permitter = document.getElementById('permitter')
        const permitDetails = document.getElementById('permitDetails')
        this.setRequiredStyle(permitter)
        this.setRequiredStyle(permitDetails)
        return {
          status: 'error',
          message: '営業時間外です。日程を確認してください。\n\n上長に許可をいただいた場合は\n投稿ボタン上の許可済みボタンにチェックしてください。',
          error_type: '時間'
        }
      }
    }
  }

  checkTime(target, start, end) {
    if(start == 'CLOSE' || end == 'CLOSE') {
      const permitElements = document.querySelectorAll('.schedule_permit')
      permitElements.forEach(this.showElement)
      const permitter = document.getElementById('permitter')
      const permitDetails = document.getElementById('permitDetails')
      this.setRequiredStyle(permitter)
      this.setRequiredStyle(permitDetails)
      return {
        status: 'error',
        message: '営業時間外です。日程を確認してください。\n\n上長に許可をいただいた場合は\n投稿ボタン上の許可済みボタンにチェックしてください。',
        error_type: '時間'
      }
    }

    this.timeToDate = (time) => {
      let date = new Date();
      let [hour, minute, second = 0] = time.split(":").map(Number);
      date.setHours(hour, minute, second, 0);
      return date;
    }

    start = this.timeToDate(start).getTime();
    end = this.timeToDate(end).getTime();
    target = this.timeToDate(target).getTime();
  
    return start <= target && end >= target? 1: 0;
  }

  checkOutlet() {
    if((this.ng_outlet_1 || this.ng_outlet_2) && this.param.outlet_array.length > 0) {
      const match = [];
      for ( let i = 0; i < this.param.outlet_array.length; i++) {
        const outlet_number = this.param.outlet_array[i];

        if (this.ng_outlet_1.indexOf(outlet_number) > -1 || this.ng_outlet_2.indexOf(outlet_number) > -1) {
          match.push(outlet_number);
        }
      }

      if(match.length > 0) {
        const permitElements = document.querySelectorAll('.schedule_permit')
        permitElements.forEach(this.showElement)
        const permitter = document.getElementById('permitter')
        const permitDetails = document.getElementById('permitDetails')
        this.setRequiredStyle(permitter)
        this.setRequiredStyle(permitDetails)
        return {
          status: 'error',
          message: `NGアウトレットが選択されています\n${match.join(' ')}\n営業スケジュールを確認してください。\n\n上長に許可をいただいた場合は\n投稿ボタン上の許可済みボタンにチェックしてください。`,
          error_type: 'アウトレット'
        }
      } else {
        return {
          status: 'ok',
          message: '選択したアウトレットに問題はありません'
        }
      }
    } else {
      return {
        status: 'ok',
        message: 'NGアウトレットなし'
      }
    }
  }

  loadingEnd(message) {
    alert(message);
    this.param.loader('営業スケジュールチェック完了');
  }
}